import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Code } from 'lucide-react';
import AuthForm from '../auth/AuthForm';
import Hero from './Hero';

const LandingPage = () => {
  const [isSignUp, setIsSignUp] = useState(true);
  const navigate = useNavigate();

  const handleAuthSuccess = () => {
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <nav className="bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Code className="w-6 h-6 text-gray-900" />
              <span className="text-2xl font-bold text-gray-900">AdSpotter</span>
            </div>
            <div className="flex items-center gap-4">
              <button
                onClick={() => setIsSignUp(false)}
                className={`text-sm font-medium ${
                  !isSignUp ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                Sign In
              </button>
              <button
                onClick={() => setIsSignUp(true)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isSignUp
                    ? 'bg-gray-900 text-white'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                Sign Up
              </button>
              <a
                href="https://github.com/yourusername/adspotter"
                className="text-gray-500 hover:text-gray-700"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            </div>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <Hero />
          <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
            <AuthForm isSignUp={isSignUp} onSuccess={handleAuthSuccess} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;